// store/folderStore.ts
import { AudioDto } from '@/service/type';
import { FolderItemType } from '@/service/type/Folder';
import create from 'zustand';

interface FolderStore {
  folderState: FolderItemType[];
  setFolderState: (folder: FolderItemType[]) => void;
}

const useFolderStore = create<FolderStore>((set) => ({
  folderState: [],
  setFolderState: (folderState: FolderItemType[]) => {
    set({ folderState });
  },
}));

export default useFolderStore;
